import { useState, useEffect } from 'react';
import { X } from 'lucide-react';

export default function CookieConsent() {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Check if user has already accepted cookies
    const cookieConsent = localStorage.getItem('cookieConsent');
    if (!cookieConsent) {
      setIsVisible(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setIsVisible(false);
  };

  const handleDecline = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[9999] bg-black/50 flex items-end md:items-center justify-center animate-in fade-in">
      <div className="bg-white w-full md:w-full max-w-2xl md:max-w-md rounded-t-2xl md:rounded-2xl shadow-lg p-6 md:p-8 mx-0 md:mx-4 animate-in slide-in-from-bottom-5 md:slide-in-from-center">
        {/* Close button */}
        <button
          onClick={handleDecline}
          className="absolute top-4 right-4 text-gray-400 hover:text-gray-600 transition-colors"
        >
          <X className="w-5 h-5" />
        </button>

        {/* Content */}
        <div className="mb-6 pr-6">
          <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-3">
            Cookie Consent
          </h2>
          <p className="text-gray-700 text-sm md:text-base leading-relaxed mb-3">
            We use cookies to enhance your browsing experience and analyze site traffic. 
            Cookies help us understand how you interact with our website, remember your 
            preferences, and provide personalized content and services.
          </p>
          <p className="text-gray-600 text-sm md:text-base">
            By clicking "Accept", you consent to our use of cookies in accordance with our{' '}
            <a
              href="/privacy"
              className="text-primary hover:underline font-medium"
            >
              Privacy Policy
            </a>
            . You can change your preferences at any time.
          </p>
        </div>

        {/* Actions */}
        <div className="flex flex-col sm:flex-row gap-3">
          <button
            onClick={handleDecline}
            className="flex-1 px-4 py-3 text-gray-700 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-colors text-sm md:text-base"
          >
            Decline
          </button>
          <button
            onClick={handleAccept}
            className="flex-1 px-4 py-3 text-white bg-primary hover:bg-primary/90 rounded-lg font-medium transition-colors text-sm md:text-base"
          >
            Accept Cookies
          </button>
        </div>
      </div>
    </div>
  );
}
